import { normalizeLedgerFields } from "../../lib/ledger-field-compat";
import type { ExpenseInput } from "../../types";

// A Smart Add conversation in progress, kept on the device for a day so a lost tab loses nothing.

export type SmartMessage = { role: "user" | "assistant"; content: string };
export type SmartDraft = {
  messages: SmartMessage[];
  text: string;
  expenses: ExpenseInput[];
  stage: "chat" | "review";
  updated: number;
};

/** Smart Add conversations are kept short; past this many messages the person reviews or restarts. */
export const MAX_SMART_MESSAGES = 16;

export const smartDraftKey = (profile: string) => `barnyard-smart-draft-${profile}`;

export const emptySmartDraft = (): SmartDraft => ({
  messages: [],
  text: "",
  expenses: [],
  stage: "chat",
  updated: Date.now(),
});

export function restoreSmartDraft(key: string): SmartDraft {
  try {
    const v = normalizeLedgerFields(JSON.parse(localStorage.getItem(key) || "null"));
    if (
      v &&
      Date.now() - v.updated < 86400000 &&
      Array.isArray(v.messages) &&
      v.messages.length <= MAX_SMART_MESSAGES &&
      v.messages.every(
        (m: SmartMessage) =>
          ["user", "assistant"].includes(m.role) &&
          typeof m.content === "string",
      ) &&
      typeof v.text === "string" &&
      ["chat", "review"].includes(v.stage)
    )
      return {
        ...v,
        expenses: Array.isArray(v.expenses)
          ? v.expenses
          : v.expense
            ? [v.expense]
            : [],
      };
  } catch {
    /* Storage is optional until saving. */
  }
  return emptySmartDraft();
}
